<template>
    <Card :title="$route.meta.title" dis-hover>
        <Form inline @keydown.enter.native.prevent="refreshGetTableData">
            <FormItem>
                <Input v-model="query.name" placeholder="请输入姓名" clearable=""></Input>
            </FormItem>
            <FormItem>
            <Input v-model="query.idcardNo" placeholder="请输入身份证号" clearable=""></Input>
            </FormItem>
            <FormItem>
                <Button type="primary" icon="ios-search" @click="refreshGetTableData">查询</Button>
            </FormItem>
            <Button type="success" icon="md-add" @click="handleOperation(null,'ADD')">
                添加
            </Button>
        </Form>

        <Table :loading="tableLoading" :columns="tableColumns" :data="tableList">
            <template slot-scope="{row}" slot="qualifyVoucher">
                <a class="opt-txt" @click="showVoucher(row.qualifyVoucher)">点击查看</a>
            </template>

            <template slot-scope="{row}" slot="operation">
                <a class="opt-txt" @click="handleOperation(row,'EDIT')">编辑</a>
                <a class="opt-txt" @click="handleOperation(row,'DELETE')">删除</a>
            </template>
        </Table>
        <page-model :paging="page" :total="total" @page-change="handlePageChange"></page-model>

        <Modal title="从业资格证查看" v-model="voucherShow" :footer-hide="true"><img :src="imgUrl|prepandImg"  style="width: 100%" /></Modal>

        <Modal v-model="modalVisible" :title="modalTitle">
            <Spin size="large" fix v-if="modalLoading"></Spin>
            <Form ref="baseForm" :model="modalForm" :label-width="100">
                <FormItem label="姓名" prop="name" :rules="[rules.required]">
                    <Input v-model="modalForm.name" placeholder="姓名"></Input>
                </FormItem>
                <FormItem label="联系电话" prop="mobile" :rules="[rules.required]">
                    <Input type="tel" v-model="modalForm.mobile" placeholder="联系电话"></Input>
                </FormItem>
                <FormItem label="身份证号" prop="idcardNo" :rules="[rules.required]">
                    <Input v-model="modalForm.idcardNo" placeholder="身份证号"></Input>
                </FormItem>
                <FormItem label="从业资格" prop="qualifyVoucher" :rules="[rules.required]">
                    <do-picture v-model="modalForm.qualifyVoucher"></do-picture>
                </FormItem>
                <FormItem label="到期时间" prop="expireTime" :rules="[rules.required]">
                    <DatePicker type="datetime" placeholder="到期时间" style="width: 200px" :value="modalForm.expireTime" @on-change="expireChange"></DatePicker>
                </FormItem>
            </Form>
            <div slot="footer">
                <Button @click="modalVisible = false">取消</Button>
                <Button type="primary" @click="handleSubmit">确定</Button>
            </div>
        </Modal>
    </Card>
</template>
<script>
    import iEquip from '@/module/main/api/iEquip';
    import tableHelper from '@/mixins/tableHelper';
    import rules from '@/libs/rules';
    import DoPicture from '@/components/auto-form/DoPicture';
    import EquipSearch from '@/module/main/components/EquipSearch';
    import _don from '@/libs/doson'

    const modalFormTemplate = {
        id: null,
        name:null,
        mobile:null,
        idcardNo: null,
        qualifyVoucher:null,
        expireTime:null,
    };

    export default {
        name: "operator_mng",
        mixins: [tableHelper],
        components: {
            DoPicture
        },
        data() {
            return {
                rules,
                query:{
                    name:null,
                    idcardNo:null
                },
                tableColumns:[
                    {title: '序号', key: 'idx', width: 80},
                    {title: '姓名', key: 'name', width: 100},
                    {title: '联系方式', key: 'mobile'},
                    {title: '身份证号码', key: 'idcardNo'},
                    {title: '资格证', slot: 'qualifyVoucher', width: 120},
                    {title: '到期时间', key: 'expireTime'},
                    {title: '操作', slot: 'operation', width: 200}
                ],

                modalTitle:'添加操作手',
                modalVisible:false,
                modalLoading:false,
                modalForm:_don.cloneWithModal(modalFormTemplate),

                imgUrl:'',
                voucherShow:false,
            }
        },
        mounted() {
            this.getTableData()
        },
        methods: {
            getTableData() {
                if (this.query.name == '') {
                    this.query.name = null
                }
                if (this.query.idcardNo == '') {
                    this.query.idcardNo = null
                }
                iEquip.operatorList(this.page, this.query).then(res => {
                    var i = 1
                    this.tableList = res.content.map(e => {
                        e.idx = (this.page.page-1)*this.page.size+i++
                        return e
                    });
                    this.total = res.totalElements
                }).loadingSwitch(this, 'tableLoading');
            },
            showVoucher(voucher) {
                this.imgUrl = voucher
                this.voucherShow = true
            },
            async handleOperation(row, type) {
                if (type === 'ADD') {
                    this.$refs.baseForm.resetFields();
                    this.modalTitle = '添加操作手'
                    this.modalVisible = true
                    this.modalForm = _don.cloneWithModal(modalFormTemplate)
                    return;
                }
                if (type === 'EDIT') {
                    this.$refs.baseForm.resetFields();
                    this.modalTitle = '编辑操作手'
                    this.modalVisible = true
                    this.modalForm = row
                    return;
                }
                if (type === 'DELETE') {
                    this.$Modal.confirm({
                        title: '提示',
                        content: `该操作将删除姓名为“${row.name}”的操作手，确认继续？`,
                        onOk: () => {
                            iEquip.operatorDelete(row.id).then(() => {
                                this.$Message.success('操作成功');
                                this.getTableData();
                            }).loadingSwitch(this, 'tableLoading');
                        }
                    });
                    return;
                }
            },
            handleSubmit() {
                this.$refs.baseForm.validate(val => {
                    if (!val) return;
                    iEquip.operatorAdd(this.modalForm).then(() => {
                        this.$Message.success('操作成功');
                        this.getTableData()
                        this.modalVisible = false
                    });
                });
            },
            expireChange(v) {
                this.modalForm.expireTime = v
            }
        },
        watch:{

        },
        filters:{
            prepandImg(url){
                if(url){
                    return '/supervise'+url
                }
                return null
            }
        }
    }
</script>

<style scoped lang="less">

</style>
